<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  name: "Bar-Chart",
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      ...this.options
    });
  },
  watch: {
    chartData() {
      this.renderChart(this.chartData, {
        responsive: true,
        maintainAspectRatio: false,
        ...this.options
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
